import * as bus from "@sinch/bus";
import { z } from "zod";
import { assignFeatureFlags } from "./config/feature-flags/config-cat-client";
import { featureFlagContractAtom } from "./featureFlags";
import { globalJotaiStore } from "./jotai-store";

const FFUser = z
  .object({
    identifier: z.string(),
    email: z.string().optional(),
    country: z.string().optional(),
    custom: z.record(z.string(), z.string()),
  })
  .partial();

const unsub = bus.listen((message) => {
  if (bus.isData(message)) {
    const parsed = FFUser.safeParse(message.payload);
    if (parsed.success) {
      const existingContract = globalJotaiStore.get(featureFlagContractAtom);
      const newContract = {
        identifier: parsed.data.identifier || existingContract.identifier || "",
        email: parsed.data.email || existingContract.email || "",
        country: parsed.data.country || existingContract.country || "",
        custom: {
          ...existingContract.custom,
          ...parsed.data.custom,
        },
      };

      assignFeatureFlags(newContract);
    }
  }
}, bus.isOverrideFFUserEvent);

window.addEventListener("unload", unsub);
